import React, { memo } from "react";
import SnippetPreview from "./SnippetPreview";
import MediaCarouselPreview from "./MediaCarouselPreview";
import AssessmentOpportunityPreview from "./AssessmentOpportunityPreview";
import CaseStudySolutionSnippetPreview from "./CaseStudySolutionSnippetPreview";
import FileUploadPreview from "./FileUploadPreview";
import { LEARNING_UNIT_COMPONENT_TYPES } from "../../../constants/types";

const LearningUnitComponentPreview = ({ luc }) => {
  const pageURL = window.location.pathname;

  switch (luc.type) {
    case LEARNING_UNIT_COMPONENT_TYPES.SNIPPET:
      return (
		// CKEditor v18 used comment and suggestion tags as below 
		// <comment id=\"eaf119cd216bdcda798ba2919e62d647c\" type=\"start\"></comment>dummy<comment id=\"eaf119cd216bdcda798ba2919e62d647c\" type=\"end\"></comment>
		// <suggestion id="e84dc7737584b2c1a76e1d1afe04d6985:003Bo00000Z9rDuIAJ" suggestion-type="deletion" type="start"></suggestion>standard<suggestion id="e84dc7737584b2c1a76e1d1afe04d6985:003Bo00000Z9rDuIAJ" suggestion-type="deletion" type="end"></suggestion>
		// CKEditor v48 uses comment and suggestion tags  as below 
		// <comment-start name=\"ee6477a01c403a338fb97ef55178dc461:9f6fe\"></comment-start>bliss of souls<comment-end name=\"ee6477a01c403a338fb97ef55178dc461:9f6fe\"></comment-end>
		// <suggestion-start name="insertion:eec99295feffd52eaa7bb9ea8aff8a564:0038s00000wpkygAAA"></suggestion-start>-<suggestion-end name="insertion:eec99295feffd52eaa7bb9ea8aff8a564:0038s00000wpkygAAA"></suggestion-end>
		// <suggestion-start name="deletion:ee3c569d7d914a30a3ea22243457b237a:0038s00000wpkygAAA"></suggestion-start>industry<suggestion-end name="deletion:ee3c569d7d914a30a3ea22243457b237a:0038s00000wpkygAAA"></suggestion-end>
        <SnippetPreview
          html={
            !luc.html
              ? luc.html
              : luc.html
                  .replace(new RegExp(/<suggestion[^>]*suggestion-type="deletion" type="start"><\/suggestion>[^<]*|<suggestion-start[^>]*name="deletion:[^"]*"[^>]*><\/suggestion-start>[^<]*/, "ig"), "")
				  .replace(new RegExp(/<\/?(comment|suggestion)[^>]*>/, "ig"), "")
          }
          styleClass={`snippet ${luc.styleClass || ""}`}
          pageURL={pageURL}
        />
      );
    case LEARNING_UNIT_COMPONENT_TYPES.CASE_STUDY_SOLUTION_SNIPPET:
      return <CaseStudySolutionSnippetPreview html={luc.html} styleClass={`snippet ${luc.styleClass || ""}`} pageURL={pageURL} />;
    case LEARNING_UNIT_COMPONENT_TYPES.MEDIA_CAROUSEL:
      return <MediaCarouselPreview fileList={luc.fileList} />;
    case LEARNING_UNIT_COMPONENT_TYPES.ASSESSMENT_OPPORTUNITY:
      return <AssessmentOpportunityPreview luc={luc} />;
    case LEARNING_UNIT_COMPONENT_TYPES.FILE_UPLOAD:
      return <FileUploadPreview fileList={luc.fileList} fileName={luc.fileName} />;
    default:
      return null;
  }
};

export default memo(LearningUnitComponentPreview);
